var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Practice/AddPractice/steps/AddPracticeSecondStep.tsx";
import React, { useState } from 'react';
import { Divider, HStack, IconValidationValid, Stack, Text } from '@adc/parallax-component-library';
import { PracticeErrorCode } from 'Enums';
import { useApiError, useLibrePractice, useToast } from 'Hooks';
import { Button, Footer, Main, RichText, ScrollContainer, Spinner, TitleActionBar } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { applyPhoneNumberMask, getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const InfoComponent = ({
  label,
  text,
  withDivision,
  testID
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: `${testID}-label`,
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }, label), /*#__PURE__*/React.createElement(Text, {
    testID: testID,
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 7
    }
  }, text), withDivision && /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 24
    }
  }));
};
const AddPracticeSecondStep = ({
  values: practiceConnection,
  back
}) => {
  const [loading, setLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showToast
  } = useToast();
  const {
    addPractice
  } = useLibrePractice();
  if (!practiceConnection) {
    mediator.publish('router:navigate', '/connections');
    return null;
  }
  const displayMessageError = modalProps => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: modalProps
    });
  };
  const handleClickBtnBack = () => {
    back();
  };
  const onPrivacyNoticeLinkClick = () => {
    const {
      documentsUrl,
      documents
    } = store.getState().config;
    const {
      language
    } = store.getState().lang;
    const privacyNoticePath = getDocumentPathFromLanguage(documents?.privacypolicy, language);
    if (privacyNoticePath) {
      const privacyNoticeFullUrl = `${documentsUrl}${privacyNoticePath}`;
      window.open(privacyNoticeFullUrl, '_blank');
    }
  };
  const handleConnectButton = async () => {
    try {
      setLoading(true);
      const {
        errorCode,
        practiceBody
      } = await addPractice(practiceConnection.practiceId);
      if (practiceBody) {
        showToast({
          message: i18n.t('Connections.modals.practiceAddedToast.body'),
          'aria-label': i18n.t('Connections.modals.practiceAddedToast.body'),
          icon: /*#__PURE__*/React.createElement(IconValidationValid, {
            color: "$support.positive.default",
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 111,
              columnNumber: 17
            }
          })
        });
        return mediator.publish('router:navigate', {
          url: '/lv-practice-connection',
          data: {
            practiceConnection: practiceBody
          }
        });
      }
      switch (errorCode) {
        case PracticeErrorCode.TOO_MANY_CONNECTIONS:
          displayMessageError({
            details: i18n.t('Connections.modals.maxPracticesError.body'),
            testID: 'TooManyConnections'
          });
          break;
        default:
          showApiErrorModal();
      }
    } catch {
      showApiErrorModal();
    } finally {
      setLoading(false);
    }
  };
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    testID: "AddPracticeID.primaryText",
    title: i18n.t('Connections.content.confirmPractice.primaryText'),
    closeBtn: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    "aria-label": "loading",
    testID: "AddPracticeID.spinner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 144,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(ScrollContainer, {
    marginTop: 19,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "AddPracticeID.secondaryText",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    lineHeight: "$bodyBase.default",
    color: "$text.100",
    marginHorizontal: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.confirmPractice.secondaryText')), /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    padding: "$4",
    marginTop: "$2",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 156,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "AddPracticeID.title",
    color: "$text.100",
    fontWeight: "$h4.medium",
    fontSize: "$h4.medium",
    marginBottom: "$7",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 11
    }
  }, practiceConnection.name), /*#__PURE__*/React.createElement(InfoComponent, {
    label: i18n.t('Connections.content.confirmPractice.formField.practiceID.label'),
    text: practiceConnection.businessId,
    withDivision: true,
    testID: "AddPracticeID.formField.practiceID",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(InfoComponent, {
    label: i18n.t('Connections.content.confirmPractice.formField.practiceAddress.label'),
    text: `${practiceConnection.address1}, ${practiceConnection.city}, ${practiceConnection.state} ${practiceConnection.zip}`,
    withDivision: true,
    testID: "AddPracticeID.formField.practiceAddress",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(InfoComponent, {
    label: i18n.t('Connections.content.confirmPractice.formField.practicePhoneNumber.label'),
    testID: "AddPracticeID.formField.practicePhoneNumber",
    text: applyPhoneNumberMask(practiceConnection.phoneNumber),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 185,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: "",
    customProps: /*#__PURE__*/React.createElement(Stack, {
      marginHorizontal: "$3",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 197,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(RichText, {
      text: i18n.t('Connections.content.pendingInvitation.bodyText'),
      color: "$text.60",
      testID: "AddPracticeID.secondary.bodyText",
      onPressLink: onPrivacyNoticeLinkClick,
      fontToken: "$labelBase.default",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 198,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      marginTop: "$4",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 205,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Button, {
      marginRight: "$2",
      onPress: handleClickBtnBack,
      testID: "AddPracticeID.common.back",
      "aria-label": i18n.t('Global.microcopy.common.back'),
      label: i18n.t('Global.microcopy.common.back'),
      flexGrow: 1,
      variant: "secondary",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 206,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Button, {
      marginLeft: "$2",
      onPress: handleConnectButton,
      testID: "AddPracticeID.common.connect",
      "aria-label": i18n.t('Global.microcopy.common.connect'),
      label: i18n.t('Global.microcopy.common.connect'),
      flexGrow: 1,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 215,
        columnNumber: 15
      }
    }))),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 7
    }
  }));
};
export default AddPracticeSecondStep;